import r from"lodash.last";var t=function(t){return Number(r(t.split("/")))};export{t as getIdFromKey};
//# sourceMappingURL=ReactTreeAccordion.helpers.js.map
